/**
 * @generated SignedSource<<c672df7540026746c518fc6252bb9853>>
 * @relayHash 03d60ddb2ab7e66f9166484b433a6391
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID edf50ab9067bb9d2788c9b405debcf23a384aa2eb6e7a5692942760f437f397f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { srcVirtualAgentViewStandardFlowQuery } from './srcVirtualAgentViewStandardFlowQuery.graphql';

import checkForAiEnabledFF_provider from '@atlassian/jira-relay-provider/src/jsm-va-is-require-ai-enabled.relayprovider';

const node: PreloadableConcreteRequest<srcVirtualAgentViewStandardFlowQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "edf50ab9067bb9d2788c9b405debcf23a384aa2eb6e7a5692942760f437f397f",
    "metadata": {},
    "name": "srcVirtualAgentViewStandardFlowQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": checkForAiEnabledFF_provider
    }
  }
};

export default node;
